import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Spinner} from '@npck/libs/commons';

@Component({
    selector: 'ui-kit-switch',
    templateUrl: 'switch.component.html',
    styleUrls: ['switch.component.scss'],
    standalone: false,
})
export class SwitchComponent {
    @Input() spinnerId: string;
    @Input() ngModel: boolean = false;
    @Output() ngModelChange = new EventEmitter<SwitchEvent>();

    Spinner = Spinner;

    setValue(value: boolean, silent = false): void {
        this.ngModel = value;
        if (!silent) {
            this.ngModelChange.emit({source: this, value});
        }
    }
}

export interface SwitchEvent {
    source: SwitchComponent;
    value: boolean;
}
